import { Component, Input } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
declare var mdtoast: any;
var success_message3 = mdtoast("Evaluation Dr Hery", { duration: 5000, init: true, type: mdtoast.SUCCESS });


@Component({
  selector: 'app-modal-content',
  template: `
  <div class="modal-header">
      <h5 class="modal-title text-center">{{nom_dr}}</h5>
      <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
      </button>
  </div>

  <div class="modal-body"> 
  <video title="{{nom_dr}}" preload="auto" controls width="400" class="center-block">
      <source src="assets/video/dr/{{video_name}}" type="video/mp4">
      <p>{{nom_dr}}</p>
  </video>
  <div class="text-center">
      <figcaption>Médecin spécialiste diplômé d'Etat</figcaption>
      <figcaption>Dentiste</figcaption>
      <figcaption>  ONM: 700 </figcaption>        
      <figcaption>Porte :03</figcaption>
      <figcaption>Lieu : Tsiazotafo</figcaption>
     

  </div>
  </div>










  <div class="modal-footer">
  <div class="left-side">
      <button type="button" class="btn btn-default btn-link" (click)="Evaluation()">Evaluation</button>
  </div>
  <div class="divider"></div>
  <div class="right-side">
      <button type="button" class="btn btn-danger btn-link" (click)="activeModal.close('Close click')">Fermer</button>
  </div>
</div>
  `
})
export class NgbdModalContent_her {
  @Input() name;
  nom_dr: string = "Dr Hery";
  //video_name: string = "dr_roland.mp4";
  video_name: string = "dr_hery3.mp4";

  constructor(public activeModal: NgbActiveModal,private router: Router) {
    
  }
  
  Evaluation(){

    Swal.fire({
        title: 'Evaluation Dr Hery',
        icon: 'info',
        text: 'Réception, Disponibilité, niveau de concentretion, qualité de diagnostique, matériels,....',
        // icone: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Oui, Evalué!',
        cancelButtonText: 'Non'
      }).then((result) => {
        if (result.value) {
          //ok btn
          success_message3.show();  
          this.activeModal.close('Close click')
         this.router.navigate(['evaluation/'+66]);
        } else if (result.dismiss === Swal.DismissReason.cancel) {
        //cancel btn
        }
      });     
    }
}
@Component({
  selector: 'app-video-dr-hery',
  templateUrl: './video-dr-hery.component.html',
  styleUrls: ['./video-dr-hery.component.scss']
})
export class VideoDrHeryComponent  {

  focus: any;
  focus1: any;
 
  constructor(private modalService: NgbModal) { }
    open() {
        const modalRef = this.modalService.open(NgbdModalContent_her);
        modalRef.componentInstance.name = 'World';
    }
    ngOnInit() {
    }

}
